const getTimezoneOffsetString = () => {
  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteOffset = Math.abs(offsetMinutes);
  const hours = String(Math.floor(absoluteOffset / 60)).padStart(2, '0');
  const minutes = String(absoluteOffset % 60).padStart(2, '0');

  return `${sign}${hours}:${minutes}`;
};

export const toReportStartDate = (dateValue) =>
  `${dateValue}T00:00:00.000${getTimezoneOffsetString()}`;

export const toReportEndDate = (dateValue) =>
  `${dateValue}T23:59:59.000${getTimezoneOffsetString()}`;

export const formatReportDate = (dateValue) => {
  if (!dateValue) return '-';

  return new Date(dateValue).toLocaleString('es-UY', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatReportAmount = (amount) =>
  new Intl.NumberFormat('es-UY', { style: 'currency', currency: 'UYU' }).format(amount ?? 0);

export const formatAmazonWeight = (value) => {
  if (value === null || value === undefined || value === '') return '-';

  const num = Number(value);

  if (Number.isNaN(num)) return '-';
  if (Number.isInteger(num)) return String(num);

  return num.toFixed(2);
};

export const REPORT_SALES_PAGE_SIZE = 20;
export const UYU_TO_USD_RATE = 41;

export const isCanceledOrderStatus = (status) => {
  const normalized = String(status || '').trim().toLowerCase();

  // Solo estados cancelados de ML. Cualquier otro (paid, delivered, etc.) usa la fórmula normal.
  return normalized === 'canceled' || normalized === 'cancelled';
};

export const getTotalUsaUyu = (amazonPrice, shipping) =>
  (Math.floor(Number(amazonPrice)) + Math.floor(shipping)) * UYU_TO_USD_RATE;

export const getTotalGananciaUyu = ({ totalNeto, amazonPrice, shipping, statusOrder }) => {
  if (shipping == null) return null;

  const totalUsaUyu = getTotalUsaUyu(amazonPrice, shipping);

  if (isCanceledOrderStatus(statusOrder)) {
    return -totalUsaUyu;
  }

  if (totalNeto == null) return null;

  return totalNeto - totalUsaUyu;
};

export const getTotalGananciaTextClassName = (amount, statusOrder) => {
  if (isCanceledOrderStatus(statusOrder) || (amount != null && amount < 0)) {
    return 'text-red-700 font-semibold';
  }

  if (amount != null && amount > 0) {
    return 'text-green-700 font-semibold';
  }

  return 'text-gray-900 font-semibold';
};

export const getTotalGananciaFooterClassName = (amount) => {
  if (amount == null) {
    return 'text-gray-900 font-bold bg-gray-50';
  }

  if (amount < 0) {
    return 'text-red-700 font-bold bg-red-50';
  }

  if (amount > 0) {
    return 'text-green-700 font-bold bg-green-50';
  }

  return 'text-gray-900 font-bold bg-gray-50';
};
